<template>
  <div
    class="col preview"
  >
    <div class="card w-100 h-100 d-flex flex-column">
      <div class="card-header">
        {{ $t("labels.preview") }}
      </div>
      <div class="window-body d-flex flex-column flex-fill p-3">
        <div class="preview-top pb-2">
          <div class="card overflow-auto h-100">
            <SettingPreviewImage
              :image="image"
              class="card-body"
            />
          </div>
        </div>
        <div class="preview-bottom pt-2">
          <SettingPreviewArea
            ref="previewArea"
            :list="settingList"
            :message-display-flg="messageDisplayFlg"
            :stdb-flg="stdbFlg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingPreviewArea from "@/components/organisms/SettingPreviewArea.vue"
import SettingPreviewImage from "@/components/atoms/SettingPreviewImage.vue"
export default {
  name: "PreviewContainer",
  components: { SettingPreviewArea, SettingPreviewImage },
  props: {
    settingList: {
      type: Array,
      default: function () {
        return []
      },
    },
    image: {
      type: String,
      default: function () {
        return ""
      },
    },
    stdbFlg: {
      type: Boolean,
      default: function (){
        return false
      }
    },
    messageDisplayFlg: Boolean,
  },
  data: () => ({
    currentId: 1,
  }),
  methods: {
    initializeId: function () {
      this.$refs.previewArea.setCurrentId(this.currentId)
    },
  },
}
</script>
<style lang="scss" scoped>
.preview {
  height: 100%;

  .card-header {
    border-bottom: none;
    background: var(--bs-table-header);
    color: var(--bs-layout-theme);
    font-weight: bold;
  }
}

.window-body {
  position: relative;
  min-height: 0;
}
.preview-top {
  min-height: 0;
  flex: 0 0 50%;
}
.preview-bottom {
  min-height: 0;
  flex: 0 0 50%;
}
</style>
